/**
 * Checs if we're currently in browser and not at some server-side build step
 * @returns boolean
 */
export function isBrowser () {
  return typeof window !== 'undefined'
};
